import React, { useState, useEffect, ReactNode } from 'react';

interface GlobalState {
  receiptnumber: string;
  tel: string;
  invoiceDetail?: any;
  globalStateFormData?: any;
}

const initialState: GlobalState = {
  receiptnumber: '',
  tel: '',
  invoiceDetail: undefined,
  globalStateFormData: undefined
};

export const GlobalStateContext = React.createContext<{
  globalState: GlobalState;
  setGlobalState: React.Dispatch<React.SetStateAction<GlobalState>>;
}>({
  globalState: initialState,
  setGlobalState: () => { },
});

interface GlobalStateProviderProps {
  children: ReactNode;
}

export const GlobalStateProvider: React.FC<GlobalStateProviderProps> = ({ children }) => {
  const [globalState, setGlobalState] = useState(() => {
    const localData = localStorage.getItem('globalState');
    return localData ? JSON.parse(localData) : initialState;
  });

  useEffect(() => {
    localStorage.setItem('globalState', JSON.stringify(globalState));
  }, [globalState]);

  return (
    <GlobalStateContext.Provider value={{ globalState, setGlobalState }}>
      {children}
    </GlobalStateContext.Provider>
  );
};